module.exports = __webpack_public_path__ + "static/media/DSC_0305.fc467bfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0305.jpg
// module id = 662
// module chunks = 0